import get from 'lodash/get';
import RegistrationState from './state';
import { RegistrationTypes } from './types';
import { REGISTRATION_STATUS } from './const';

const INITIAL_STATE = new RegistrationState();

export default function registrationReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // USER_REGISTER
    case RegistrationTypes.USER_REGISTER.LOADING:
      return {
        ...state,
        registration: {
          ...INITIAL_STATE.registration,
          loading: true,
        },
      };
    case RegistrationTypes.USER_REGISTER.SUCCESS:
      return {
        ...state,
        registration: {
          ...INITIAL_STATE.registration,
          data: action.payload,

          error: null,
        },
        verification: {
          ...INITIAL_STATE.verification,
          data: get(action.payload, 'token')
            ? REGISTRATION_STATUS.verify_skipped
            : REGISTRATION_STATUS.verify_in_progress,
        },
      };
    case RegistrationTypes.USER_REGISTER.ERROR:
      return {
        ...state,
        registration: {
          ...INITIAL_STATE.registration,
          error: action.payload,
        },
      };

    // USER_VERIFICATION
    case RegistrationTypes.USER_VERIFICATION.LOADING:
      return {
        ...state,
        verification: {
          ...INITIAL_STATE.verification,
          loading: true,
        },
      };
    case RegistrationTypes.USER_VERIFICATION.SUCCESS:
      return {
        ...state,
        verification: {
          ...INITIAL_STATE.verification,
          data: REGISTRATION_STATUS.verify_success,
        },
      };
    case RegistrationTypes.USER_VERIFICATION.ERROR:
      return {
        ...state,
        verification: {
          ...INITIAL_STATE.verification,
          data: REGISTRATION_STATUS.verify_failed,
          error: action.payload,
        },
      };

    // USER_VERIFICATION_RESEND
    case RegistrationTypes.USER_VERIFICATION_RESEND.LOADING:
      return {
        ...state,
        verificationResend: {
          ...INITIAL_STATE.verificationResend,
          loading: true,
        },
      };
    case RegistrationTypes.USER_VERIFICATION_RESEND.SUCCESS:
      return {
        ...state,
        verificationResend: {
          ...INITIAL_STATE.verificationResend,
          data: action.payload,
        },
      };
    case RegistrationTypes.USER_VERIFICATION_RESEND.ERROR:
      return {
        ...state,
        verificationResend: {
          ...INITIAL_STATE.verificationResend,
          error: action.payload,
        },
      };

    default:
      return state;
  }
}
